import React from 'react';

/** One line-icon family for the tool strip: 24px grid, round 1.8 strokes in the text colour. */
const Icon = ({ children }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const DownloadIcon = () => (
    <Icon>
        <path d="M12 4v11M8 11l4 4 4-4" />
        <path d="M4 19h16" />
    </Icon>
);

/** A page with a two-way arrow through its edge: the map's file comes in or goes out. */
export const FileTransferIcon = () => (
    <Icon>
        <path d="M8 9V5a2 2 0 0 1 2-2h5l5 5v11a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-4" />
        <path d="M15 3v5h5" />
        <path d="M3 12h9M5 10l-2 2 2 2M10 10l2 2-2 2" />
    </Icon>
);

/** Clear the whole map: a broom, distinct from deleting one node. */
export const ClearIcon = () => (
    <Icon>
        <path d="M20 4l-7.5 7.5" />
        <path d="M10.4 9.4l4.2 4.2-4.3 5.7-5.6-5.6z" />
        <path d="M12.5 11.5l-5 5" />
    </Icon>
);

export const PrintIcon = () => (
    <Icon>
        <rect x="6" y="9" width="12" height="7" rx="1" />
        <path d="M7 9V4h10v5M8 16v4h8v-4" />
    </Icon>
);
